import React from "react";

const WinLossDrawIcon = ({ score, className }) => {
  const [homeScore, awayScore] = score.split(":").map(Number);

  return (
    <p
      className={`${
        homeScore > awayScore
          ? "bg-green-600"
          : homeScore < awayScore
            ? "bg-red-500"
            : "bg-orange-500"
      } py-1 font-bold ${className}`}
    >
      {homeScore > awayScore ? "W" : homeScore < awayScore ? "L" : "D"}
    </p>
  );
};

const StreakSmallOpponent = ({ game }) => {
  return (
    <div className="w-8 space-y-0.5 pb-1 text-center text-sm">
      <WinLossDrawIcon score={game.Score} />
      <p className="font-bold">{game.Score}</p>
      {game.AwayTeam?.logoUrl && (
        <img
          src={game.AwayTeam.logoUrl}
          alt={game.AwayTeam.Name}
          className="mx-auto aspect-square w-5 rounded-full"
        />
      )}
    </div>
  );
};

export default StreakSmallOpponent;
